import { Head } from "@inertiajs/react";
import { t } from "@travily/i18n";
import { rootPath } from "@travily/routes";
import { PageFrame } from "@/layouts/page-frame";
import { ResentView } from "./resent.view";

interface DownloadResentProps {
  masked_email: string;
}

const DownloadResentPage = ({ masked_email }: DownloadResentProps) => (
  <PageFrame>
    <Head title={t("web.purchases.downloads.resent.meta_title")} />

    <ResentView homeHref={rootPath()} maskedEmail={masked_email} />
  </PageFrame>
);

export default DownloadResentPage;
